import React, { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';

import ButtonSp from '../../components/ButtonSp';
import InputTextSp from '../../components/InputTextSp';
import LabelSp from '../../components/LabelSp';
import MessageInputText from '../../components/MessageInputText';

import AuthService from '../../services/AuthService';
import LicencaService from '../../services/LicencaService';

import { errorHandle } from '../../util/functions';
import { formataData, formataDataHora, formataVersao } from './util';
import LicencaCrudEvento from './crudEvento';

// Detalhe de uma instalacao (vinculo contrato -> servidor do SpeedyAgent): situacao
// comercial calculada pela central, trocas de servidor na janela e o historico.
// Acoes: revogar esta instalacao e desbloquear o limite de trocas do contrato.
function LicencaCrud(props) {
  LicencaCrud.propTypes = {
    idSelected: PropTypes.number.isRequired,
    onClose: PropTypes.func.isRequired,
  };

  const { idSelected, onClose } = props;

  const [licenca, setLicenca] = useState({});
  const [dialogo, setDialogo] = useState(''); // '' | 'revogar' | 'desbloquear'
  const [recarregarEventos, setRecarregarEventos] = useState(0);

  const loadRecord = useCallback(async _id => {
    try {
      setLicenca(await LicencaService.findById(_id));
    } catch (err) {
      errorHandle(err);
    }
  }, []);

  useEffect(() => {
    loadRecord(idSelected);
  }, [loadRecord, idSelected]);

  const podeAlterar = AuthService.checkRoles('LICENCA_ALTERAR');
  const ativa = licenca.id && !licenca.dataHoraRevogacao;
  const cliente = licenca.cliente || {};

  async function confirmaDialogo(motivo) {
    const acao = dialogo;
    setDialogo('');
    try {
      if (acao === 'revogar') {
        await LicencaService.revogar(licenca.id, motivo);
        toast.success('Licença revogada. O servidor para no próximo ciclo do agente.');
      } else {
        await LicencaService.desbloquear(licenca.idCliente, motivo);
        toast.success('Limite de trocas zerado para o contrato.');
      }
      await loadRecord(licenca.id);
      setRecarregarEventos(recarregarEventos + 1);
    } catch (err) {
      errorHandle(err);
    }
  }

  function campo(label, valor, classe = 'p-col-6 p-sm-4 p-lg-2 p-fluid') {
    return (
      <div className={classe}>
        <LabelSp>{label}</LabelSp>
        <InputTextSp
          value={valor === undefined || valor === null ? '' : String(valor)}
          disabled
        />
      </div>
    );
  }

  return (
    <>
      {campo('Contrato', cliente.numeroContrato)}
      {campo('Cliente', cliente.nome, 'p-col-12 p-sm-8 p-lg-6 p-fluid')}
      {campo('Situação', ativa ? 'Ativa' : 'Revogada')}
      {campo('Cliente inativo', cliente.inativo ? 'Sim' : 'Não')}

      {campo('Servidor', licenca.nomeMaquina, 'p-col-12 p-sm-6 p-lg-3 p-fluid')}
      {campo('Versão do agente', formataVersao(licenca.versaoAgente))}
      {campo('Id da base', licenca.idInstalacao, 'p-col-12 p-sm-6 p-lg-4 p-fluid')}
      {campo(
        'Ativada em',
        formataDataHora(licenca.dataHoraAtivacao),
        'p-col-6 p-sm-4 p-lg-3 p-fluid'
      )}

      {campo(
        'Última renovação',
        formataDataHora(licenca.dataHoraUltimaRenovacao),
        'p-col-6 p-sm-4 p-lg-3 p-fluid'
      )}
      {campo('Vencimento', formataData(licenca.vencimento))}
      {campo('Bloqueia em', formataData(licenca.bloqueiaEm))}
      {campo(
        'Trocas de servidor (30 dias)',
        `${licenca.trocasNaJanela || 0} de 3`,
        'p-col-6 p-sm-4 p-lg-3 p-fluid'
      )}

      {licenca.dataHoraRevogacao ? (
        <>
          {campo(
            'Revogada em',
            formataDataHora(licenca.dataHoraRevogacao),
            'p-col-6 p-sm-4 p-lg-3 p-fluid'
          )}
          {campo(
            'Motivo da revogação',
            licenca.motivoRevogacao,
            'p-col-12 p-sm-8 p-lg-9 p-fluid'
          )}
        </>
      ) : null}

      <div className="p-col-12 p-lg-12" style={{ textAlign: 'start' }}>
        {ativa ? (
          <ButtonSp
            className="p-button-danger"
            icon="pi pi-ban"
            label="Revogar"
            disabled={!podeAlterar}
            title="O servidor deste contrato para de renovar e o sistema bloqueia ao fim da credencial atual"
            onClick={() => setDialogo('revogar')}
          />
        ) : null}
        <ButtonSp
          className="p-button-warning"
          icon="pi pi-unlock"
          label="Desbloquear trocas"
          disabled={!podeAlterar || !licenca.idCliente}
          title="Zera a contagem de trocas de servidor do contrato (use quando a troca for legítima)"
          onClick={() => setDialogo('desbloquear')}
        />
        <ButtonSp
          className="p-button-secondary"
          label="Voltar"
          icon="pi pi-chevron-circle-left"
          keyAccess="V"
          onClick={onClose}
        />
      </div>

      {licenca.idCliente ? (
        <LicencaCrudEvento
          idCliente={Number(licenca.idCliente)}
          recarregar={recarregarEventos}
        />
      ) : null}

      {dialogo ? (
        <MessageInputText
          title={dialogo === 'revogar' ? 'Motivo da revogação' : 'Motivo do desbloqueio'}
          caption="Motivo"
          messageVisible
          handleOk={confirmaDialogo}
          handleClose={() => setDialogo('')}
        />
      ) : null}
    </>
  );
}

export default LicencaCrud;
